module ProcessList {
    import IModalInstance = angular.ui.bootstrap.IModalServiceInstance;

    export class RunOnceModalController {
        static $inject = ["$uibModalInstance", "manualTriggerParameters",];
        constructor(private $modalInstance: IModalInstance, public manualTriggerParameters: any[]) {
            console.log(manualTriggerParameters);
        }

        private convertArrayToObject(obj, array) {
            array.forEach((item) => {
                obj[item.name] = item.nonStringifiedDefaultValue;
            });
        }

        public confirm() {
            var stringStringDictonary = {};
            this.convertArrayToObject(stringStringDictonary, this.manualTriggerParameters);
            this.$modalInstance.close(stringStringDictonary);
        };

        public cancel() {
            this.$modalInstance.dismiss();
        }
    }

    module.controller("RunOnceModalController", RunOnceModalController);
}